module.exports = __webpack_public_path__ + "static/media/frosttherm_at.24701ab9.pdf";